<template>
    <div id="echart-pie" style="height: 450px;width:90%;"></div>   
</template>

<script>

export default({
    props:{
        'plotData':Array,
        'name':String,
    },
    watch:{
        plotData:function(){
            this.initChart()
        }
    },
    mounted(){
        this.initChart()
    },
    methods: {
        initChart() {  
            this.pieChart = this.echarts.init(document.getElementById("echart-pie"));
            const option={
                color: ['#dd4444', '#fec42c', '#80F1BE'],
                grid: {
                    left: '5%',
                    right: 200,
                    top: '10%',
                    bottom: '10%',
                    containLabel: true
                },
                tooltip: {
                    backgroundColor: 'rgba(255,255,255,0.7)',
                    formatter: function (param) {
                    var value = param.value;
                    return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                            + value[1] 
                            + '</div>'
                            + 'ID: ' + value[4] + '<br>'
                            + 'Count: ' + value[3] + '<br>'
                            + 'Gene ratio: ' + value[8] + '<br>'
                            + 'Bg ratio: ' + value[5] + '<br>'
                            + 'pvalue: ' + value[6].toExponential(3) + '<br>'
                            + 'qvalue: ' + value[7].toExponential(3) + '<br>'
                            + '-log10(p.adjust): ' + value[2] + '<br>'
                    }
                },
                xAxis: { 
                    type: 'value',
                    name: 'GeneRatio',
                    nameGap: 16,
                    nameTextStyle: {
                        fontSize: 16
                    },
                    splitLine: {
                        show: true
                    },
                    nameTextStyle:{
                        rich:{
                            sub: {
                            verticalAlign: "bottom",
                            fontSize: 8
                            }
                        }
                    }
                },
                yAxis: {
                    type:'category',
                    name: this.name,
                    nameLocation: 'start',
                    nameGap: 20,
                    splitLine: {
                        show: true
                    },
                    inverse: true
                },
                series: [{
                    type: 'scatter',
                    data:this.plotData
                }],
                visualMap: [
                    {
                        // orient: "horizontal",
                        left: 'right',
                        bottom: '10%',
                        dimension: 2,
                        itemHeight: 120,
                        min: 11,
                        max: 38,
                        text: ['-log{sub|10}(p.adjust)'],
                        textGap: 30,
                        inRange: {
                            color: ['red','blue']
                        },
                        outOfRange: {
                            color: ['rgba(255,255,255,0.4)']
                        },
                        controller: {
                            inRange: {
                                color: ['red','blue']
                            },
                            outOfRange: {
                                color: ['#999']
                            }
                        },
                        textStyle:{
                            rich:{
                                sub: {
                                verticalAlign: "bottom",
                                fontSize: 8
                                }
                            }
                        }
                    },
                    {
                        left: 'right',
                        top: '10%',
                        dimension: 3,
                        itemWidth: 30,
                        itemHeight: 120,
                        calculable: true,
                        precision: 0.1,
                        text: ['Count'],
                        textGap: 30,
                        inRange: {
                            symbolSize: [10,70]
                        },
                        outOfRange: {
                            symbolSize: [10,70],
                            color: ['rgba(255,255,255,0.4)']
                        },
                        controller: {
                            inRange: {
                            color: ['#c23531']
                            },
                            outOfRange: {
                            color: ['#999']
                            }
                        }
                    },
                ],
               
            }
            this.pieChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.pieChart.resize();
            });
        }
    }
})
</script>
